import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import "./HistoryPage.css";
import BASE_URL from "../../../../config/apiConfig";

const HistoryPage = () => {
  const { transactionId } = useParams();
  const location = useLocation();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { cropname } = location.state || {};

  console.log(cropname);
  
  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/user/crop-clinic/history/${transactionId}`
        );
        setHistory(response.data.history);
        console.log(response.data.history);
        
        setLoading(false);
      } catch (error) {
        setError("Failed to fetch history. Please try again later.");
        setLoading(false);
      }
    };

    fetchHistory();
  }, [transactionId]);

  return (
    <div className="history-page">
      <h1 className="history-title">History for {cropname}</h1>

      {loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
        </div>
      ) : error ? (
        <div className="error-container">
          <p className="error-message">{error}</p>
        </div>
      ) : history.length === 0 ? (
        <div className="empty-container">
          <p className="empty-message">No history found for this subscription.</p>
        </div>
      ) : (
        <div className="history-list">
          {history.map((entry, index) => (
            <div className="history-card" key={index}>
              <div className="history-image">
                {entry.image_name ? (
                  <img src={`${BASE_URL}/media/crop_images/${entry.image_name}`} alt={`Crop ${entry.crop_name}`} />
                ) : (
                  <div className="placeholder-image">No Image Available</div>
                )}
              </div>
              <div className="history-details">
                <h2 className="crop-name">{entry.crop_name}</h2>
                <p>
                  <strong>Diagnosis:</strong> {entry.diagnosis}
                </p>
                <p>
                  <strong>Precautions:</strong> {entry.precaution}
                </p>
                <p className="history-date">
                  <strong>Analyzed On:</strong>{" "}
                  {new Date(entry.created_at).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HistoryPage;
